import dayjs, { Dayjs } from "dayjs";
import { EXCHANGE_TIMEZONE } from "./dayjsSetup";

/**
 * A contract's delivery window as `MM-DD HH:mm - HH:mm` — date, start, end — on
 * the venue's clock.
 *
 * Derived from the delivery timestamps rather than from the venue's product
 * string, which is an opaque identifier. Accepts either dayjs values (the config
 * form holds them parsed) or ISO strings (the order book rows carry them raw).
 *
 * Returns `undefined` when the window is unknown, so callers can fall back to
 * whatever name they already had.
 */
export const formatDeliveryWindow = (
  start?: Dayjs | string | null,
  end?: Dayjs | string | null
): string | undefined => {
  if (!start || !end) {
    return undefined;
  }

  const from = dayjs(start);
  const to = dayjs(end);
  if (!from.isValid() || !to.isValid()) {
    return undefined;
  }

  // Spaced hyphen, so the separator does not read as part of either time.
  return `${from.tz(EXCHANGE_TIMEZONE).format("MM-DD HH:mm")} - ${to
    .tz(EXCHANGE_TIMEZONE)
    .format("HH:mm")}`;
};
